/* ==========================================================================
   Satjeevan — Product Testimonials JS (product-testimonials.js)

   The two rows are pure CSS `@keyframes` marquees (GPU-accelerated
   `transform: translateX()`), not a per-frame JS animation loop — this file
   only measures each row once (and on resize) to set an accurate
   `--sj-ptm-duration` so the scroll speed matches the design reference's
   18px/second regardless of how many testimonial blocks a merchant adds.

   Every row renders its unique set of cards twice back-to-back (the second
   copy is aria-hidden) so a translateX(-50%) loop is always seamless; moving
   that same distance in a duration proportional to its measured width keeps
   the speed constant no matter how many cards are in the row.
   ========================================================================== */

(function () {
  'use strict';

  var SPEED_PX_PER_SECOND = 18;
  var RESIZE_DEBOUNCE_MS = 200;

  function measureTrack(track) {
    var group = track.querySelector('.sj-ptm-group');
    if (!group) return;

    var width = group.getBoundingClientRect().width;
    if (!width) return;

    var duration = width / SPEED_PX_PER_SECOND;
    track.style.setProperty('--sj-ptm-duration', duration + 's');
  }

  function measureAll() {
    var tracks = document.querySelectorAll('[data-sj-ptm-track]');
    tracks.forEach(measureTrack);
  }

  function init() {
    measureAll();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(measureAll, RESIZE_DEBOUNCE_MS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme Editor live-reload support
  document.addEventListener('shopify:section:load', measureAll);
})();
